import React from 'react';
import Layout from './components/Layout/Layout';

// eslint-disable-next-line react/prop-types
const Page = ({ element, props }) => <Layout {...props}>{element}</Layout>;

export default Page;
